import { useContext } from 'react'
import PermissionContext from './PermissionContext'
import { PermissionProvider } from './type'

export const usePermissionProvider = (): PermissionProvider => {
  return useContext(PermissionContext)
}
